import axios from "axios";
import { AuthenticateDIDType } from "../types/login.type";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";

const authenticateDID = async ({
  ledgerAddress,
  token,
}: AuthenticateDIDType) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/authenticate-did`,
      { LedgerAddress: ledgerAddress },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error("Network response was not ok");
  }
};

export default authenticateDID;
